<template>
    <div class="base-title">
        <h3>{{title}}</h3>
    </div>
</template>

<script>

export default ({
    name: 'BaseTitle',
    props:{
        title: {
            type: String,
            default: "标题名称title"
        }
    },
    data() {
        return{
            
        }   
    },
})
</script>
<style lang="less" scoped>
.base-title{
    h3{
        text-align: left;
        color: red;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/BaseTitle.vue